import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Award, X } from "lucide-react";

interface EliteVIPLightboxProps {
  open: boolean;
  onClose: () => void;
  paymentLink?: string;
}

const EliteVIPLightbox = ({ open, onClose, paymentLink }: EliteVIPLightboxProps) => {
  const defaultPaymentLink = "https://connect.intuit.com/pay/Venture24/scs-v1-546ab3219a574050bda67734df9112080fe4e363fb924f8b91cee95101d9f7d2920b9289cd584be5ab9708a3c900910a?locale=EN_US";

  const handleJoinVIP = () => {
    onClose();
    window.location.href = paymentLink || defaultPaymentLink;
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => {
      if (!isOpen) onClose();
    }}>
      <DialogContent className="sm:max-w-[600px] overflow-auto max-h-[90vh]">
        <DialogClose asChild onClick={onClose} className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none">
          <button>
            <X className="h-4 w-4" />
            <span className="sr-only">Close</span>
          </button>
        </DialogClose>
        
        <DialogHeader className="text-center">
          <DialogTitle className="text-2xl sm:text-3xl font-bold text-center mb-2">AI App Elite VIP</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="mx-auto w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-4">
            <Award className="h-8 w-8 text-purple-600" />
          </div>
          
          <div className="text-center mb-6">
            <div className="text-4xl font-bold mb-2">$4,999<span className="text-lg font-normal text-gray-500">/one-time</span></div>
            <p className="text-gray-600">We Build & Launch Your AI App for You—From Idea to Market</p>
          </div>
          
          <div className="space-y-3">
            <div className="flex items-start gap-2">
              <div className="h-5 w-5 mt-0.5 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <p>Custom app development tailored to your specific needs</p>
            </div>
            <div className="flex items-start gap-2">
              <div className="h-5 w-5 mt-0.5 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <p>Professional UI/UX design creating beautiful experiences</p>
            </div>
            <div className="flex items-start gap-2">
              <div className="h-5 w-5 mt-0.5 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <p>Branding & identity creation for a memorable presence</p>
            </div>
            <div className="flex items-start gap-2">
              <div className="h-5 w-5 mt-0.5 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <p>Monetization strategy to generate revenue</p>
            </div>
            <div className="flex items-start gap-2">
              <div className="h-5 w-5 mt-0.5 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <p>Complete launch campaign to attract first users</p>
            </div>
            <div className="flex items-start gap-2">
              <div className="h-5 w-5 mt-0.5 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <p>Marketing materials to promote your app</p>
            </div>
            <div className="flex items-start gap-2">
              <div className="h-5 w-5 mt-0.5 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <p>App store optimization for maximum visibility</p>
            </div>
            <div className="flex items-start gap-2">
              <div className="h-5 w-5 mt-0.5 flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <p>VIP support throughout the entire process</p>
            </div>
          </div>
          
          <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white"
              onClick={handleJoinVIP}
            >
              Join Elite VIP
            </Button>
            <Button 
              variant="outline" 
              onClick={onClose} 
              className="w-full sm:w-auto"
            >
              Not Now
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EliteVIPLightbox;
